<div class="card mb-3">

    <div class="card-header">
        <span translate>contract.options.info</span>
    </div>

    <div class="card-body">

        <mat-form-field class = "full-width">
            <mat-label translate>contract.options.field.customName</mat-label>
            <input [(ngModel)]="_guided_creation.customName" matInput required>
        </mat-form-field>

        <mat-form-field class = "full-width">
            <mat-label translate>contract.options.field.operatorName</mat-label>
            <input [(ngModel)]="_guided_creation.operatorName" matInput required>
        </mat-form-field>

        <mat-checkbox [(ngModel)] = "_guided_creation.stima">
            <span translate>contract.options.field.stima</span>
        </mat-checkbox>
    </div>
</div>